import { useEffect } from 'react';

export const useGetUserExternalReview = ({
    publicUserId,
    userShowLoading,
    onGetUserExternalReview,
}) => {
    useEffect(() => {
        if (!publicUserId || userShowLoading) {
            return;
        }

        onGetUserExternalReview(publicUserId);
    }, [publicUserId, userShowLoading]);
};
